<template>
  <div class="cy-data" :class="{ 'cy-data--dense': dense }">
    <span v-for="(it, i) in items" :key="i" class="cy-data-cell">
      <span v-if="it.label" class="cy-data-label">{{ it.label }}</span>
      <span class="cy-data-value">{{ it.value }}</span>
    </span>
  </div>
</template>

<script setup>
// The mono data strip — catalogue no., format, BPM, key, duration,
// seller. Items with an empty label render value-only (tight tiles).
// (No vue runtime APIs used — defineProps is a compiler macro.)
defineProps({
  /* Array<{ label?: string, value: string|number }> */
  items: { type: Array, default: () => [] },
  dense: { type: Boolean, default: false }
})
</script>

<style scoped>
.cy-data {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  row-gap: 2px;
  font-family: var(--cy-mono);
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  min-width: 0;
}
.cy-data--dense { font-size: 0.62rem; }

.cy-data-cell {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  min-width: 0;
  padding: 0 8px;
  border-left: 1px solid var(--cy-line);
}
.cy-data--dense .cy-data-cell { padding: 0 6px; gap: 4px; }
.cy-data-cell:first-child { padding-left: 0; border-left: none; }

.cy-data-label { color: var(--text-dim); font-weight: 500; flex-shrink: 0; }
.cy-data-value {
  color: var(--text-muted);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
